import axios from 'axios';

const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const EDGE_FUNCTION_URL = isLocal
  ? '/supabase-api'
  : 'https://jxhmtsfnpcmacydqpwex.supabase.co/functions/v1/dynamic-action';

export const customerApi = {
  /**
   * Customer Signup
   * @param {Object} data - { name, mobile, password }
   */
  async signup({ name, mobile, password }) {
    try {
      const response = await axios.post(`${EDGE_FUNCTION_URL}?action=signup`, {
        name,
        mobile,
        password
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Signup failed. Please try again.';
      throw new Error(errorMessage);
    }
  },

  /**
   * Customer Login
   * @param {Object} data - { mobile, password }
   */
  async login({ mobile, password }) {
    try {
      const response = await axios.post(`${EDGE_FUNCTION_URL}?action=login`, {
        mobile,
        password
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      const serverMsg = error.response?.data?.error || error.response?.data?.message;
      if (serverMsg && serverMsg.toLowerCase().includes('deleted')) {
        throw new Error('This account has been deleted.');
      }
      const errorMessage = serverMsg || 'Invalid mobile number or password.';
      throw new Error(errorMessage);
    }
  },

  /**
   * Fetch current customer profile
   * @param {string} token - customer_token
   */
  async getCurrentCustomer(token) {
    try {
      const response = await axios.post(`${EDGE_FUNCTION_URL}?action=me`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Failed to fetch customer profile.';
      throw new Error(errorMessage);
    }
  },

  /**
   * Delete customer account
   * @param {string} token - customer_token
   * @param {string} password - customer password
   */
  async deleteAccount(token, password) {
    try {
      const response = await axios.post(`${EDGE_FUNCTION_URL}?action=delete`, {
        password
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Failed to delete account. Please verify your password.';
      throw new Error(errorMessage);
    }
  }
};
